import React from "react";
import style from "./styles";
import { IconShare, rdcUiTheme, Type } from "@rdc-npm/rdc-ui";
import PropTypes from "prop-types";
import { trackOmnitureClicks } from "static/staticData/omniture/omnitureUtils";
import { OMNITURE_LINK_NAME } from "static/staticData/omniture/trackingConstants";

export default function ShareProfile(props) {
  const showShareModal = (m) => {
    trackOmnitureClicks(props.linkName ? props.linkName : OMNITURE_LINK_NAME.ADP.SHARE);
    if (props.showShareModal) {
      props.showShareModal(m);
    }
  };

  return (
    <>
      <style jsx>{style}</style>

      <div
        data-testid="component-shareProfile"
        className={
          props && props.stickyHeader
            ? "contact-info-number-text sticky-share"
            : "contact-info-number-text"
        }>
        <div className="icon-number-text" id={props && props.stickyHeader ? null : "exceptHeader"}>
          {" "}
          <IconShare
            color={rdcUiTheme.color.interactive.primary.default.initial}
            size={3}
            role="img"
            focusable="false"
            aria-label="component-shareProfile"></IconShare>
        </div>
        <div
          className="preview-contact-number"
          onClick={() => showShareModal(props && props.agentdetail)}>
          <a
            href="#"
            id="sharemodal"
            className="track-my-clicks mobile-number"
            data-linkname={
              props.linkName ? props.linkName : "realtors:agent_details:top:share-start"
            }>
            <Type styleType="body300">Share profile</Type>
          </a>
        </div>
      </div>
    </>
  );
}

ShareProfile.propTypes = {
  showShareModal: PropTypes.func,
  stickyHeader: PropTypes.bool,
  agentdetail: PropTypes.object,
  linkName: PropTypes.string,
};
